(async () => {
    const { Core } = await importModule('Core');
    const { NoUiSlider } = await importModule('NoUiSlider');

    customElements.define('collection-filter-price', class extends Core {
        elements = {
            slider: '[data-slider]',
            min: '[data-min]',
            max: '[data-max]',
            inputMin: '[data-input-min]',
            inputMax: '[data-input-max]'
        }

        // True only after the user has actively dragged the slider, or when price
        // params are already present in the URL (restored on collection:updated).
        _priceChanged = false;

        render() {
            this._restoreFromUrl();
            this._initSlider();
            this.slider.on('change', this._sliderChangeHanlder.bind(this));
            this.subscribe('collection:updated', { global: true });
        }

        _restoreFromUrl() {
            const params = new URLSearchParams(window.location.search);
            if (params.has('filter.v.price.gte') || params.has('filter.v.price.lte')) {
                this._priceChanged = true;
            }
        }

        _initSlider() {
            this.slider = NoUiSlider.create(this.$slider, {
                start: [
                    +this.getAttribute('current-min'),
                    +this.getAttribute('current-max')
                ],
                connect: true,
                range: {
                    min: +this.getAttribute('min'),
                    max: +this.getAttribute('max')
                }
            })
        }

        _sliderChangeHanlder([ min, max ]) {
            this._priceChanged = true;
            this.$inputMin.disabled = false;
            this.$inputMax.disabled = false;
            this.$inputMin.value = Math.round(min);
            this.$inputMax.value = Math.round(max);
            this.publish('filter:change');
        }

        // After every AJAX filter update, re-evaluate whether price params exist
        // in the new URL so the slider state is correctly preserved or cleared.
        _onCollectionUpdated() {
            this._restoreFromUrl();
            if (!this._priceChanged) {
                this.$inputMin.disabled = true;
                this.$inputMax.disabled = true;
            }
        }

        subscriptions = { 'collection:updated': '_onCollectionUpdated' }

        disconnect() {
            this.slider.destroy();
        }
    })
})();